export default __webpack_public_path__ + "static/media/benchmark.e4f02c7b.png";